import { render, staticRenderFns } from "./MagneticFluxViz.vue?vue&type=template&id=05197bb2&scoped=true"
import script from "./MagneticFluxViz.vue?vue&type=script&lang=js"
export * from "./MagneticFluxViz.vue?vue&type=script&lang=js"
import style0 from "./MagneticFluxViz.vue?vue&type=style&index=0&id=05197bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05197bb2",
  null
  
)

export default component.exports